import {Component, OnInit} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {MenuItemModel} from '../../../../shared/models/menu-item.model';
import {ActivityReportService} from '../../../activity-report/services/activity-report.service';

@Component({
  selector: 'classic-to-generate',
  templateUrl: './classic-to-generate.component.html',
  styleUrls: ['./classic-to-generate.component.scss'],
})
export class ClassicToGenerateComponent implements OnInit {
  menu: MenuItemModel[] = [];

  constructor(
    private activityReportService: ActivityReportService,
    private translateService: TranslateService,
  ) {}

  ngOnInit(): void {
    this.activityReportService.getPendingInvoicesCount().subscribe({
      next: response => {
        this.menu = [
          new MenuItemModel(this.translateService.instant('Mission_view.billing.activity_sheets'), 'activity-sheets', response.activitySheet),
          new MenuItemModel(this.translateService.instant('Mission_view.billing.due_date'), 'due-payments', response.duePayment),
          new MenuItemModel(this.translateService.instant('Mission_view.billing.on_call'), 'on-calls', response.onCall),
          new MenuItemModel(this.translateService.instant('Mission_view.billing.fees'), 'fees', response.fee),
          new MenuItemModel(this.translateService.instant('Mission_view.billing.regulations'), 'regulations', response.regulation),
        ];
      }
    });
  }
}
